/** @jsxImportSource @emotion/react */
import React from 'react'
import { StylesObject } from "types"
import { Widgets, Widget } from '../../widgets'
import { useParams } from 'react-router-dom'
import { styles as carouselStyles } from './WidgetCarousel'

//
// 3rd party websites can embed free widgets in an iFrame
// This container renders a single widget by id without headers/footers
//

const WidgetById = () => {

  const { id }: any = useParams()
  const validWidget = Widgets[id] && !Widgets[id].groups.length // allow all free widgets to be embedded for now

  return (
    <div css={styles.container}>
    { validWidget ?
      <Widget 
        id={id}
        disableFullScreen
        showAttribution
        fadeIn
        icon={false}
      /> :
      <h1>{id} is not a valid widget id</h1> }
    </div>
  )
}

const styles = {
  container: theme => {
    const styled: any = carouselStyles.container
    const base = styled(theme)
    return {
      ...base,
      backgroundColor: '#003b59',
      '& .graph': {
        ...base['& .graph'],
        height: 'calc(100vh - 100px)',
        [theme.breakpoints.only('xs')]: {
          height: 'calc(100vh - 60px)',
        },
      }
    }
  } 
} as StylesObject

export default WidgetById